import React, { useEffect, useState } from 'react';
import { Alert, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import feedbackService from '@/shared/services/feedbackService';

const MESSAGES = {
    400: 'This link does not point to a feedback screenshot.',
    403: 'Only administrators can view feedback screenshots.',
    404: 'This screenshot is not available. It may have been removed.',
};
const FALLBACK = "The screenshot couldn't be loaded. Please try again.";

/**
 * Shows a screenshot attached to filed feedback. The GitHub issue links here
 * rather than to the image itself, because the API needs the administrator's
 * token and only the signed-in app can send it.
 */
function FeedbackScreenshotPage() {
    const { id } = useParams();
    const [imageUrl, setImageUrl] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        let objectUrl = '';
        let cancelled = false;
        setImageUrl('');
        setError('');
        feedbackService
            .getScreenshot(id)
            .then((blob) => {
                if (cancelled) return;
                objectUrl = URL.createObjectURL(blob);
                setImageUrl(objectUrl);
            })
            .catch((err) => {
                if (cancelled) return;
                setError(MESSAGES[err.response?.status] || FALLBACK);
            });
        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [id]);

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col lg={10}>
                    <h1 className="h3 mb-3">Feedback screenshot</h1>
                    {error && (
                        <Alert variant="danger" role="alert">
                            {error}
                        </Alert>
                    )}
                    {!error && !imageUrl && (
                        <div role="status">
                            <Spinner animation="border" size="sm" /> Loading the
                            screenshot...
                        </div>
                    )}
                    {imageUrl && (
                        <img
                            src={imageUrl}
                            alt="Screenshot attached to a feedback report"
                            className="img-fluid border"
                        />
                    )}
                </Col>
            </Row>
        </Container>
    );
}

export default FeedbackScreenshotPage;
